import * as React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import TaxonomyProjectTypeTeaser from './Teaser';
import TaxonomyProjectTypePage from './Page';
import TaxonomyProjectTypeTitle from './Title';
import type { TaxonomyProjectType } from '../../../types/uncinc_profile/taxonomy';

type TaxonomyViewmode = 'teaser' | 'page' | 'title';

interface TaxonomyProjectTypeWrapperProps {
  entity: ImmutableEntity<TaxonomyProjectType>;
  viewMode: TaxonomyViewmode;
}

const TaxonomyProjectTypeWrapper: React.FC<TaxonomyProjectTypeWrapperProps> =
  ({ entity, viewMode, ...props }) => {
    switch (viewMode) {
      case 'teaser':
        return <TaxonomyProjectTypeTeaser entity={entity} {...props} />;
      case 'title':
        return <TaxonomyProjectTypeTitle entity={entity} {...props} />;
      case 'page':
      default:
        return <TaxonomyProjectTypePage entity={entity} {...props} />;
    }
  };

export default TaxonomyProjectTypeWrapper;
